// extracted by mini-css-extract-plugin
export default {"btnContainer":"Payment_btnContainer__MHm3s","btnSend":"Payment_btnSend__hbLcJ","container":"Payment_container__zoolc","textField":"Payment_textField__I67d-"};